import CollapsibleSection from "ds/components/CollapsibleSection";
import Box from "ds/components/Box";

import { content } from "./content";
import LaunchPadVideosItem from "./Item";

const LaunchPadVideos = () => {
  return (
    <CollapsibleSection
      title="Watch videos"
      ariaLevel={2}
      ariaLabel="Watch videos"
      initialIsCollapsed={false}
    >
      <Box grid gridTemplate="1fr 1fr 1fr 1fr" gap="large">
        {content.map(({ title, videoId, backgroundClass }) => (
          <LaunchPadVideosItem
            key={videoId}
            title={title}
            videoId={videoId}
            backgroundClass={backgroundClass}
          />
        ))}
      </Box>
    </CollapsibleSection>
  );
};

export default LaunchPadVideos;
